<section class="register-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-image">
                <img
                    src="assets/img/pexels-karolina-grabowska-4021766.png"
                    alt="image"
                />
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="register-form">
                            <div class="logo">
                                <a routerLink="/"
                                    ><img
                                        src="assets/img/black-logo.png"
                                        alt="image"
                                /></a>
                            </div>

                            <h3>{{ "Create Your Account Now" | translate }}</h3>
                            <p>
                                {{ "Already register?" | translate }} 

                                <a routerLink="/login">{{ "Login" | translate }}</a>
                            </p>

                            <form
                                name="registertionForm"
                                #registerForm="ngForm"
                            >
                                <div class="form-group mb-3">
                                    <input
                                        type="text"
                                        name="txtEmail"
                                        id="txtEmail"
                                        required
                                        class="form-control"
                                        [(ngModel)]="user.email"
                                        [placeholder]="'Email' | translate"
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="text"
                                        name="txtPatientName"
                                        id="txtPatientName"
                                        required
                                        class="form-control"
                                        [(ngModel)]="user.name"
                                        [placeholder]="
                                            'Patient Name' | translate
                                        "
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="text"
                                        name="txtNation"
                                        id="txtNation"
                                        required
                                        [(ngModel)]="user.nation"
                                        class="form-control"
                                        [placeholder]="
                                            'Patient Nation' | translate
                                        "
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="text"
                                        name="txtPhoneNumber"
                                        id="txtPhoneNumber"
                                        required
                                        [(ngModel)]="user.phone_no"
                                        class="form-control"
                                        [placeholder]="
                                            'Patient Phone Number' | translate
                                        "
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <mat-form-field>
                                        <input
                                            matInput
                                            [matDatepicker]="pickerEnd"
                                            name="txtDateOfBirth"
                                            [(ngModel)]="dateOfBirth"
                                            #ngDateOfBirth="ngModel"
                                            [placeholder]="
                                                'MM/DD/YYYY' | translate
                                            "
                                            class="form-control birthdate"
                                        />
                                        <input type="hidden" />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="pickerEnd"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #pickerEnd
                                        ></mat-datepicker>
                                        <mat-error
                                            *ngIf="
                                                ngDateOfBirth.touched &&
                                                !ngDateOfBirth.valid
                                            "
                                        >
                                            Please fill this field
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group mb-3">
                                    <mat-form-field
                                        appearance="fill"
                                        class="gender-dropdown"
                                    >
                                        <mat-label>الجنس</mat-label>
                                        <mat-select
                                            [(value)]="user.gender"
                                            required
                                            class="birthdate"
                                        >
                                            <mat-option value="male">{{
                                                "Male" | translate
                                            }}</mat-option>
                                            <mat-option value="female">{{
                                                "Female" | translate
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="password"
                                        placeholder="الرقم السري"
                                        class="form-control"
                                        name="txtPassword"
                                        [(ngModel)]="user.password"
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="password"
                                        placeholder="تأكيد الرقم السري"
                                        class="form-control"
                                        name="txtPasswordConfirmation"
                                        [(ngModel)]="passwordConfirmation"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    class="submit"
                                    (click)="register()"
                                >
                                   {{ "Signup" | translate }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
